<section class="product-feature-upgrade-banner">
  <div class="product-feature-upgrade-banner__effects" aria-hidden="true">
    <span class="product-feature-upgrade-banner__gradient"></span>
    <span
      class="product-feature-upgrade-banner__wave product-feature-upgrade-banner__wave--back"
    ></span>
    <span
      class="product-feature-upgrade-banner__wave product-feature-upgrade-banner__wave--front"
    ></span>
  </div>

  <div class="product-feature-upgrade-banner__content">
    <span class="product-feature-upgrade-banner__chip">{{
      (chipKey ? translationService.getTranslationForKey(chipKey) : null)
        | subscribe
    }}</span>

    <h2
      class="product-feature-upgrade-banner__heading"
      [innerHTML]="
        (headingKey ? translationService.getTranslationForKey(headingKey) : null)
          | subscribe
      "
    ></h2>

    <p
      class="product-feature-upgrade-banner__paragraph"
      [innerHTML]="
        (paragraphKey
          ? translationService.getTranslationForKey(paragraphKey)
          : null) | subscribe
      "
    ></p>
  </div>

  <div class="product-feature-upgrade-banner__cta">
    <tswp-product-feature-upgrade-button
      [productFeatureKey]="productFeatureKey"
      [redirectUrlParams]="redirectUrlParams"
    ></tswp-product-feature-upgrade-button>
  </div>
</section>
